import './index.css';
import { useState, useRef, useEffect } from 'react';
import { basicMetadata } from './basicMetadata.js';

const basicCountries = [...basicMetadata.keys()];
const DEFAULT_API_INSTANCE = {
    parsePhoneNumber: () => {
        throw new Error('libPhoneNumber is not initialized');
    },
    formatIncompletePhoneNumber: () => {
        throw new Error('libPhoneNumber is not initialized');
    },
    getCountryCallingCode: (countryCode) => {
        if (!basicMetadata.has(countryCode)) {
            throw new Error(`Unknown country: ${countryCode}`);
        }
        return basicMetadata.get(countryCode);
    },
    isValidPhoneNumber: () => false,
    getCountries: () => basicCountries,
    isLoaded: false,
};
const useLibPhoneNumber = (variant, mobileOnly, onLoadError) => {
    const [libPhoneNumber, setLibPhoneNumber] = useState(DEFAULT_API_INSTANCE);
    const variantRef = useRef(variant);
    const onLoadErrorRef = useRef(onLoadError);
    onLoadErrorRef.current = onLoadError;
    variantRef.current = variant;
    useEffect(() => {
        setLibPhoneNumber(DEFAULT_API_INSTANCE);
        const loadLibPhoneNumber = () => import('libphonenumber-js/core');
        let loadMetadata;
        // пути к вариантам нельзя просто сохранить в мапу и динамически доставать по ключу, потому что вебпак
        // в этом случае не может проанализировать зависимости и просто не ресолвит модули в рантайме
        if (variant === 'ru-by-kz-uz') {
            loadMetadata = () => 
            /* eslint-disable @typescript-eslint/ban-ts-comment */
            (mobileOnly
                ? // @ts-ignore
                    import('./metadata.ru_by_kz_uz.mobile-DRLt47jE.js')
                : // @ts-ignore
                    import('./metadata.ru_by_kz_uz.max-8rFsF9qA.js'));
        }
        else {
            loadMetadata = () => (mobileOnly
                ? // @ts-ignore
                    import('./metadata.mobile-BiqC0l75.js')
                : // @ts-ignore
                    import('./metadata.max-DkkFHNXW.js'));
            /* eslint-enable @typescript-eslint/ban-ts-comment */
        }
        const loadApi = () => Promise.all([loadLibPhoneNumber(), loadMetadata()]).then(([libPhoneNumber, metadata]) => {
            if (variantRef.current !== variant) {
                return;
            }
            const meta = metadata.default;
            setLibPhoneNumber({
                parsePhoneNumber: (text, defaultCountry) => libPhoneNumber.parsePhoneNumber(text, defaultCountry, meta),
                formatIncompletePhoneNumber: (text, countryCode) => libPhoneNumber.formatIncompletePhoneNumber(text, countryCode, meta),
                getCountryCallingCode: (countryCode) => libPhoneNumber.getCountryCallingCode(countryCode, meta),
                getCountries: () => libPhoneNumber.getCountries(meta),
                isValidPhoneNumber: (phoneNumber, country) => libPhoneNumber.isValidPhoneNumber(phoneNumber, country, meta),
                isLoaded: true,
            });
        });
        const onError = (error) => {
            onLoadErrorRef.current?.(error, () => {
                loadApi().catch(onError);
            });
        };
        loadApi().catch(onError);
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [variant]);
    return libPhoneNumber;
};

export { useLibPhoneNumber };
//# sourceMappingURL=useLibPhoneNumber.js.map
